export default __webpack_public_path__ + "static/media/diagram-pt.d5c1dff8.webp";